import React from "react";
import { EllipsisVertical } from "lucide-react";
import { Deck } from "@/common/decks";
import { formatDate } from "@/common/dateUtils";
import OptionsDropdown from "./OptionsDropdown";

interface DeckCardActions {
  onNavigate: (deckId: string | undefined) => void;
  onTogglePin: (deck: Deck) => void;
  onDelete: (deckId: string) => void;
  onToggleDropdown: (deckId: string | undefined) => void;
}

interface DeckCardProps {
  deck: Deck;
  isDropdownOpen: boolean;
  actions: DeckCardActions;
}

const DeckCard = React.memo<DeckCardProps>(
  ({ deck, isDropdownOpen, actions }) => {
    const { onNavigate, onTogglePin, onDelete, onToggleDropdown } = actions;

    return (
      <div className="w-80 shadow-md bg-white py-4 px-3 rounded-lg flex gap-x-2">
        <div className="grow flex flex-col gap-y-2 text-deck-primary leading-none">
          <span
            className="block font-semibold cursor-pointer hover:text-deck-primary/80 transition-colors"
            onClick={() => onNavigate(deck.id)}
          >
            {deck.name}
          </span>
          <span className="block">Modified {formatDate(deck.updated_at)}</span>
          <span className="block">
            {deck.topic
              ? deck.topic.charAt(0).toUpperCase() + deck.topic.slice(1)
              : "General"}
          </span>
        </div>
        <div className="relative shrink-0 flex items-start gap-x-2">
          <EllipsisVertical
            className="text-deck-primary cursor-pointer"
            size={20}
            onClick={(e) => {
              e.stopPropagation();
              onToggleDropdown(deck.id);
            }}
          />
          <OptionsDropdown
            isOpen={isDropdownOpen}
            position="right"
            deck={deck}
            onTogglePin={onTogglePin}
            onDelete={onDelete}
            onEdit={onNavigate}
            onClose={() => onToggleDropdown(deck.id)}
          />
        </div>
      </div>
    );
  },
);

DeckCard.displayName = "DeckCard";

export default DeckCard;
